import Layout from "../../Internal/Layout.vue";
import UsersPage from "./Users.vue";

const UsersRoutes = {
  component: Layout,
  children: [
    {
      path: "/users",
      name: "Users",
      component: UsersPage,
      meta: { requiresAuth: true, requiresMaster: true, requiresAdmin: true },
    },
  ],
};

export default UsersRoutes;
